<template>
  <div>
    <div class="resultPane" v-show="resultShow">
      <h3>
        搜索结果
        <i class="el-icon-close" @click="closeResultPane"></i>
      </h3>
      <ul>
        <li
          v-for="item in resultList"
          :key="item.index"
          @click="showChooseSchool(item)"
        >
          <i class="el-icon-location-information"></i>
          {{ item.properties.NAME }}
          <span>{{ item.properties.XIAN }}</span>
        </li>
      </ul>
    </div>
    <div class="resultPane" v-show="resultXiaoquShow">
      <h3>
        搜索结果
        <i class="el-icon-close" @click="closeResultXiaoquPane"></i>
      </h3>
      <ul>
        <li
          v-for="item in resultXiaoquList"
          :key="item.index"
          @click="showChooseSchool(item)"
        >
          <i class="el-icon-location-information"></i>
          {{ item.properties.XIAOQU }}
          <span>{{ item.properties.XIAN }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "resultPane",
  data() {
    return {
      resultShow: false,
      resultXiaoquShow: false,
      resultList: [],
      resultXiaoquList: [],
    };
  },
  methods: {
    closeResultPane() {
      this.resultShow = false;
      this.$parent.removeAll();
    },
    getResultDatas(data) {
      this.resultXiaoquShow = false;
      this.resultShow = true;
      this.resultList = data.features;
      console.log(this.resultList)
    },
    getXiaoquResultDatas(data) {
      console.log(data.features);
      this.resultShow = false;
      this.resultXiaoquShow = true;
      this.resultXiaoquList = data.features;
    },
    showChooseSchool(data) {
      this.$parent.showMyChooseSchool(data);
      this.$parent.removeAll();
    },
    closeResultXiaoquPane() {
      this.resultXiaoquShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.resultPane {
  h3 {
    box-sizing: border-box;
    padding: 10px;
    font-weight: normal;
    font-size: 16px;
    line-height: 40px;
    padding: 0;
    margin: 0;
    text-align: center;
    position: relative;
    i {
      position: absolute;
      top: 11px;
      right: 10px;
      z-index: 20005;
    }
    &:after {
      content: "";
      width: 100%;
      height: 1px;
      background-image: linear-gradient(
        to right,
        #fff,
        #ccc,
        #ccc,
        #ccc,
        #ccc,
        #ccc,
        #fff
      );
      position: absolute;
      top: 40px;
      left: 0;
      z-index: 3;
    }
  }
  ul {
    padding: 10px 15px 10px 10px;
    margin: 0;
    list-style: none;
    overflow: hidden;
    overflow-y: scroll;
    li {
      margin-left: 25px;
      padding-left: 3px;
      border-bottom: 1px solid #c0c4cc;
      position: relative;
      span {
        color: #606266;
        margin-left: 5px;
      }
      &:last-child {
        border: none;
      }
      i {
        position: absolute;
        z-index: 2;
      }
    }
  }
}

@media screen and (min-width: 767px) {
  .resultPane {
    width: 320px;
    box-sizing: border-box;
    box-shadow: 1px 1px 5px rgb(0 0 0 / 30%);
    background: #fff;
    border-radius: 5px;
    position: absolute;
    left: 140px;
    top: 160px;
    z-index: 20001;
    padding: 10px 0;
    ul {
      max-height: 600px;
      li {
        line-height: 40px;
        font-size: 14px;
        span {
          font-size: 13px;
        }
        i {
          top: 14px;
          left: -20px;
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .resultPane {
    padding: 10px;
    box-sizing: border-box;
    background: #fff;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 20006;
    ul {
      max-height: 300px;
      li {
        line-height: 35px;
        font-size: 14px;
        span {
          font-size: 12px;
        }
        i {
          top: 10px;
          left: -20px;
        }
      }
    }
  }
}
</style>
